module.exports = __webpack_public_path__ + "assets/82c79f0084a557019c77ba6f51fe738e.png";